import { motion } from "framer-motion";
import { Autoplay, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import ProjectCards from "../../Components/ProjectCard/ProjectCards";
import SectionTitle from "../../Components/SectionTitle/SectionTitle";
import { projects } from "../../Constants/Constants";
import { fadeIn, staggerContainer } from "../../Constants/FramerMotions";
import "./projects.scss";

const Projects = () => {
  return (
    <motion.div
      className="projects-container"
      id="Projects"
      variants={staggerContainer}
      initial="hidden"
      whileInView="show"
      viewport={{ once: false, amount: 0.25 }}
    >
      <div className="blur p-blur1" style={{ background: "#ABF1FF94" }}></div>
      <div className="project-header">
        <motion.div
          variants={fadeIn("right", "tween", 0.1, 0.4)}
          style={{ width: "100%" }}
        >
          <SectionTitle title="Projects" subtitle="What I Have Done So Far" />
        </motion.div>
      </div>

      <motion.div
        className="swiper-projects-wrapper"
      >
        <Swiper
          className="project-slider"
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          pagination={{
            clickable: true,
            renderBullet: (index, className) => {
              return `<span class="${className}">${index + 1}</span>`;
            },
          }}
          loop={true}
          modules={[Autoplay, Pagination]}
          breakpoints={{
            // when window width is >= 200 (mobile phones)
            200: {
              slidesPerView: 1,
              spaceBetween: 500,
            },
            // when window width is >= 768px (tablets) (ipad mini)
            768: {
              slidesPerView: 2,
              spaceBetween: 80,
            },
            // when window width is >= 820px (tablets) (ipad air)
            820: {
              slidesPerView: 2,
              spaceBetween: 60,
            },
            // when window width is >= 1200px (desktops)
            1200: {
              slidesPerView: 3,
              spaceBetween: 200,
            },

            1400: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          }}
        >
          {projects?.map((item, index) => (
            <SwiperSlide key={index}>
              <motion.div variants={fadeIn("left", "tween", 0, 0)}>
                <ProjectCards
                  name={item?.name}
                  image={item?.image}
                  demo_link={item?.demo_link}
                  key_skills={item?.key_skills}
                  github_link={item?.github}
                />
              </motion.div>
            </SwiperSlide>
          ))}

          {/* <SwiperSlide>
            <motion.div variants={fadeIn("left", "tween", 0, 0)}>
              <ProjectCards
                name={projects[0]?.name}
                image={projects[0]?.image}
                demo_link={projects[0]?.demo_link}
                key_skills={projects[0]?.key_skills}
              />
            </motion.div>
          </SwiperSlide> */}

        </Swiper>
      </motion.div>
    </motion.div>
  );
};

export default Projects;

